<template>
  <div class="video-tutorials">
    <div class="video-grid">
      <div class="video-card" v-for="(video, index) in filteredVideos" :key="index">
        <div class="video-wrapper">
          <iframe
            width="376"
            height="186"
            :src="video.embedUrl"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="video-info">
          <p>{{ video.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoTutorials",
  props: {
    searchQuery: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      videos: [
        {
          title: "Como parar de perder tempo com cotação?",
          embedUrl: "https://www.youtube.com/embed/XxsY-fH3E0s",
        },
        {
          title:
            "Sistema de Cotação - Usando o aplicativo do Club para fazer sua lista de faltas",
          embedUrl: "https://www.youtube.com/embed/rMqf5-X-U_w",
        },
        {
          title: "Quanto tempo faz que você não tem tempo?",
          embedUrl: "https://www.youtube.com/embed/xwom7EDx1NY",
        },
        {
          title:
            "Sistema de Cotação - Como verificar as ordens de compra e avaliar os fornecedores no APP do Club",
          embedUrl: "https://www.youtube.com/embed/uE8llkrd2EI",
        },
        {
          title:
            "Sistema de Cotação - Como Confirmar seus pedidos pelo Aplicativo do Club",
          embedUrl: "https://www.youtube.com/embed/UceWpuvPFbk",
        },
        {
          title:
            "Sistema de Cotação - Como utilizar o APP do Club para responder uma cotação",
          embedUrl: "https://www.youtube.com/embed/GKRKBfd4NQE",
        },
        {
          title:
            "Sistema de Cotação - Como fazer o cadastro no Club da Cotação ( Vendedor)",
          embedUrl: "https://www.youtube.com/embed/aQpbT7q0fs0",
        },
        {
          title: "Sistema de Cotação - Como lançar sua Cotação : Ambiente Desktop",
          embedUrl: "https://www.youtube.com/embed/LvBx7g6P2Xo",
        },
      ],
    };
  },
  computed: {
    filteredVideos() {
      if (!this.searchQuery) {
        return this.videos;
      }
      const query = this.searchQuery.toLowerCase();
      return this.videos.filter((video) => video.title.toLowerCase().includes(query));
    },
  },
};
</script>

<style scoped>
.video-tutorials {
  padding-top: 40px;
  padding-bottom: 40px;
  width: 100%;
  max-width: 1190px;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 376px);
  justify-content: space-between;
  gap: 35px 25px;
}

.video-card {
  width: 376px;
  transition: transform 0.3s ease;
}

.video-wrapper {
  width: 376px;
  height: 186px;
  border-radius: 8px;
  overflow: hidden;
}

.video-wrapper iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.video-info {
  padding-top: 10px;
}

.video-info p {
  color: #7c7c7c;
  font-size: 1rem;
  margin: 0;
  text-align: left;
  font-weight: 400;
  line-height: 1.4;
}

@media (max-width: 830px) {
  .video-grid {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 30px 20px;
  }
}

@media (max-width: 480px) {
  .video-grid {
    grid-template-columns: 1fr;
    gap: 25px;
    padding: 0 15px;
  }

  .video-card {
    max-width: 100%;
  }
}
</style>
